/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import notice from 'src/common/components/Notice';
import { usersAPI } from 'src/api/modules/users';
import { useHistory, useLocation } from 'react-router-dom';
import { AddAlert } from '@material-ui/icons';
import { formatDate } from 'src/utils/dates';
import FullTable from 'src/common/components/FullTable';
import PageLayout from 'src/common/components/PageLayout';
import CustomButton from 'src/common/components/CustomButton';
import { institutionsAPI } from 'src/api/modules/institutions';
import { columns, defaultFilter, filterForm, defaultSelects } from './utils/data';
import { createR } from 'src/utils/UniqueIdGenerator';
import { notificationsReAPI } from 'src/api/modules/notificationsResolutions';

const Notifications = () => {
	const location = useLocation();
	const history = useHistory();
	const [users, setUsers] = useState([]);
	const [usersKey, setUsersKey] = useState([]);
	const [pagination, setPagination] = useState(5);
	const [currentPage, setCurrentPage] = useState(1);
	const [filter, setFilter] = useState(defaultFilter);
	const [institutions, setInstitutions] = useState([]);
	const [notifications, setNotifications] = useState();
	const [totalResults, setTotalResults] = useState(null);
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		getInstitutions();
		getUsers();
	}, []);

	const getInstitutions = () => {
		setInstitutions([]);
		institutionsAPI
			.get('unidadAdministrativa')
			.then((response) => {
				if (response && response.length > 0) {
					let institutionsFlag = [];
					response.forEach((ele) => {
						institutionsFlag.push({
							value: ele.id,
							text: ele.nombre,
						});
					});
					setInstitutions([...institutionsFlag]);
				}
			})
			.catch((e) => notice('Ocurrio un error', 'error'));
	};

	const getUsers = () => {
		usersAPI
			.getAllUsersStatus()
			.then((response) => {
				if (response && response.length > 0) {
					let usersFlag = [defaultSelects];
					let usersKey = [defaultSelects];
					response.forEach((item) => {
						usersFlag.push({
							value: item.id,
							text: `${item.nombre} ${item.apellidoPaterno} ${item.apellidoMaterno}`,
						});
						usersKey.push({
							key: createR(16),
							value: item.id,
							text: item.usuario,
						});
					});
					setUsers(usersFlag);
					setUsersKey(usersKey);
				}
			})
			.catch(() => notice('Ocurrio un error', 'error'));
	};

	const getNotifications = () => {
		setNotifications([]);
		let user = filter?.user?.value === undefined ? '' : filter?.user?.value;
		let key = filter?.key?.value === undefined ? '' : filter?.key?.value;

		notificationsReAPI
			.getNotifications(
				filter.unit,
				user === '' ? key : user,
				pagination,
				currentPage
			)
			.then((response) => {
				if (response?.notificaciones?.length > 0) {
					setNotifications(response.notificaciones);
					setTotalResults(response.totalRegistros);
				}
			})
			.catch(() => notice('Ocurrio un error', 'error'));
	};
	// function formatearFecha(value) {
	// 	const fecha = new Date(value);
	// 	const dia = fecha.getDate();
	// 	const mes = fecha.toLocaleString('es-ES', { month: 'long' });
	// 	const anio = fecha.getFullYear();
	// 	const horas = fecha.getHours().toString().padStart(2, '0');
	// 	const minutos = fecha.getMinutes().toString().padStart(2, '0');

	// 	return `${dia} de ${mes} del ${anio} a las ${horas}:${minutos} hrs`;
	// }

	const handleChangeFilter = ({ target }) => {
		const { name, value } = target;
		let queryFilters = { ...filter };
		const params = new URLSearchParams();
		queryFilters = { ...queryFilters, [name]: value };
		if (name === 'user') {
			filter.key = '';
			queryFilters = { ...queryFilters, key: '' };
		}
		if (name === 'key') {
			filter.user = '';
			queryFilters = { ...queryFilters, user: '' };
		}
		params.set('unit', queryFilters.unit || '');
		params.set('userText', queryFilters?.user?.text || '');
		params.set('userValue', queryFilters?.user?.value || '');

		params.set('keyText', queryFilters?.key?.text || '');
		params.set('keyValue', queryFilters?.key?.value || '');

		history.push({ search: params.toString() });
		setFilter({ ...filter, [name]: value });
	};

	const handlePagination = (value) => {
		setPagination(value);
	};

	const onClear = () => {
		filter.unit = '';
		filter.user = '';
		filter.key = '';
		getNotifications();
	};

	const onResend = (id) => {
		notificationsReAPI
			.resendNotification(id)
			.then(() => {
				notice('Se reenvío la notificación con éxito', 'success');
			})
			.catch((e) => notice('Ocurrio un error', 'error'));
	};

	const rowExt = (data) => {
		let textdata = (
			<div style={{ maxWidth: '100%' }}>
				<p>
					<b>Fecha y hora: </b>{' '}
					{formatDate('EEEE PP, HH:mm', new Date(data.fechaEnvio))} hrs.
				</p>
				<p>
					<b>Asunto: </b> {data.asunto}
				</p>
				<p>
					<b>Usuarios: </b> {data.nombreUsuarios}
				</p>
				<p>
					<b>Unidad Administrativa: </b> {data.nombreUnidadesAdministrativas}
				</p>
				{data.fechaReenvio && (
					<p>
						<b>Fecha(s) Reenvío: </b>{' '}
						{data.fechaReenvio.split(',').map((item) => (
							<span style={{ marginRight: '2px' }}>
								{formatDate('EEEE PP, HH:mm', new Date(item))}
								{'  '}{' '}
							</span>
						))}
					</p>
				)}

				<p>
					<b>Estatus: </b> {data.estatus === false ? 'No enviado' : 'Enviado'}
				</p>
				<p>
					<b>Texto: </b> {data.contenido.replace(/(<([^>]+)>)/gi, '')}
				</p>
			</div>
		);

		return textdata;
	};

	const onEye = (id) => history.push(`/seguimiento/notificacion/${id}`);
	const onNewNotification = () => history.push('/seguimiento/nueva-notificacion');

	useEffect(() => {
		if (location.search.length > 2) {
			const params = new URLSearchParams(location.search);
			const unit = params.get('unit') || '';
			const userText = params.get('userText') || '';
			const userValue = params.get('userValue') || '';

			const keyText = params.get('keyText') || '';
			const keyValue = params.get('keyValue') || '';
			setFilter({
				...filter,
				unit: unit ? Number(unit) : '',
				user:
					userText && userValue
						? {
								value: Number(userValue),
								text: userText.replace('+', ' '),
							}
						: '',
				key:
					keyText && keyValue
						? {
								value: Number(keyValue),
								text: keyText,
							}
						: '',
			});
		}
	}, []);

	useEffect(() => {
		const timer = setTimeout(() => {
			if (!mounted) {
				getNotifications();
				setMounted(true);
			}
		}, 2000);
		return () => clearTimeout(timer);
	}, [filter]);

	useEffect(() => {
		if (mounted) {
			getNotifications();
		}
	}, [pagination, currentPage]);

	return (
		<PageLayout>
			<CustomButton
				mainText="Nueva Notificación"
				color="primary"
				className="m-3"
				icon={AddAlert}
				style={{
					position: 'absolute',
					right: 35,
				}}
				onClick={() => {
					onNewNotification();
				}}
			/>
			<FullTable
				title="Notificaciones"
				filter={filter}
				columns={columns(onResend, onEye)}
				items={notifications}
				expand={true}
				dataRow={rowExt}
				onFilterChange={handleChangeFilter}
				filterForm={filterForm(
					getNotifications,
					onClear,
					institutions,
					users,
					usersKey
				)}
				showPagination
				handlePagination={handlePagination}
				sizePerPageTable={pagination}
				totalPages={totalResults}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
			/>
		</PageLayout>
	);
};

export default Notifications;
